import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

const LabRequests = React.lazy(() => import('../pages/laboratory/LabRequests'));
const LabResults = React.lazy(() => import('../pages/laboratory/LabResults'));
const LabReports = React.lazy(() => import('../pages/laboratory/LabReports'));
const LabResultsHistory = React.lazy(() => import('../pages/laboratory/LabResultsHistory'));
const LabTestManagement = React.lazy(() => import('../pages/laboratory/LabTestManagement'));
const LaboratoryQueue = React.lazy(() => import('../pages/laboratory/LaboratoryQueue'));
const QCControl = React.lazy(() => import('../pages/laboratory/QCControl'));
const QCSettings = React.lazy(() => import('../pages/laboratory/QCSettings'));
const LeveyJenningsDashboard = React.lazy(() => import('../pages/laboratory/LeveyJenningsDashboard'));
const LabDashboard = React.lazy(() => import('../pages/laboratory/LabDashboard'));
const LabPicSettings = React.lazy(() => import('../pages/laboratory/LabPicSettings'));

// Create wrapper components for the lab result viewers to avoid prop requirements
const ExampleNewLabResultsPageWrapper: React.FC = () => {
  const LabComponent = React.lazy(() => import('../components/laboratory/NewLabResultViewer').then(module => ({ default: module.ExampleNewLabResultsPage })));
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LabComponent />
    </Suspense>
  );
};

const ExampleLabResultsPageWrapper: React.FC = () => {
  const LabComponent = React.lazy(() => import('../components/laboratory/ProfessionalLabResultViewer').then(module => ({ default: module.ExampleLabResultsPage })));
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LabComponent />
    </Suspense>
  );
};

export const getLaboratoryRoutes = () => [
  <Route key="lab-dashboard" path="/laboratory" element={<LabDashboard />} />,
  <Route key="lab-requests" path="/laboratory/requests" element={<LabRequests />} />,
  <Route key="lab-results" path="/laboratory/results" element={<LabResults />} />,
  <Route key="lab-reports" path="/laboratory/reports" element={<LabReports />} />,
  <Route key="lab-results-history" path="/laboratory/results-history" element={<LabResultsHistory />} />,
  <Route key="lab-tests" path="/laboratory/tests" element={<LabTestManagement />} />,
  <Route key="lab-queue" path="/laboratory/queue" element={<LaboratoryQueue />} />,
  <Route key="lab-qc-control" path="/laboratory/qc-control" element={<QCControl />} />,
  <Route key="lab-qc-settings" path="/laboratory/qc-settings" element={<QCSettings />} />,
  <Route key="lab-levey-jennings" path="/laboratory/levey-jennings" element={<LeveyJenningsDashboard />} />,
  <Route key="lab-pic-settings" path="/laboratory/pic-settings" element={<LabPicSettings />} />,
  <Route key="lab-new-results-test" path="/laboratory/new-results-test" element={<ExampleNewLabResultsPageWrapper />} />,
  <Route key="lab-professional-results-test" path="/laboratory/professional-results-test" element={<ExampleLabResultsPageWrapper />} />
];
